/**
 * internal helper functions
 */
import { trackConnect } from "../../analytics/track.js";
import { getCachedChainIfExists } from "../../chains/utils.js";
import { COINBASE } from "../constants.js";
import { createWalletEmitter } from "../wallet-emitter.js";
/**
 * @internal
 */
export function coinbaseWalletSDK(args) {
    const { createOptions } = args;
    const emitter = createWalletEmitter();
    let account = undefined;
    let chain = undefined;
    function reset() {
        account = undefined;
        chain = undefined;
    }
    let handleDisconnect = async () => { };
    let handleSwitchChain = async (newChain) => {
        chain = newChain;
    };
    const unsubscribeChainChanged = emitter.subscribe("chainChanged", (newChain) => {
        chain = newChain;
    });
    const unsubscribeDisconnect = emitter.subscribe("disconnect", () => {
        reset();
        unsubscribeChainChanged();
        unsubscribeDisconnect();
    });
    emitter.subscribe("accountChanged", (_account) => {
        account = _account;
    });
    return {
        id: COINBASE,
        subscribe: emitter.subscribe,
        getChain() {
            if (!chain) {
                return undefined;
            }
            chain = getCachedChainIfExists(chain.id) || chain;
            return chain;
        },
        getConfig: () => createOptions,
        getAccount: () => account,
        autoConnect: async (options) => {
            const { autoConnectCoinbaseWalletSDK } = await import("./coinbaseWebSDK.js");
            const provider = await args.providerFactory();
            const [connectedAccount, connectedChain, doDisconnect, doSwitchChain] = await autoConnectCoinbaseWalletSDK(options, emitter, provider);
            // set the states
            account = connectedAccount;
            chain = connectedChain;
            handleDisconnect = doDisconnect;
            handleSwitchChain = doSwitchChain;
            trackConnect({
                client: options.client,
                walletType: COINBASE,
                walletAddress: account.address,
            });
            // return account
            return account;
        },
        connect: async (options) => {
            const { connectCoinbaseWalletSDK } = await import("./coinbaseWebSDK.js");
            const provider = await args.providerFactory();
            const [connectedAccount, connectedChain, doDisconnect, doSwitchChain] = await connectCoinbaseWalletSDK(options, emitter, provider);
            // set the states
            account = connectedAccount;
            chain = connectedChain;
            handleDisconnect = doDisconnect;
            handleSwitchChain = doSwitchChain;
            trackConnect({
                client: options.client,
                walletType: COINBASE,
                walletAddress: account.address,
            });
            // return account
            return account;
        },
        disconnect: async () => {
            reset();
            await handleDisconnect();
        },
        switchChain: async (newChain) => {
            await handleSwitchChain(newChain);
        },
        onConnectRequested: async () => {
            if (args.onConnectRequested) {
                const provider = await args.providerFactory();
                return args.onConnectRequested?.(provider);
            }
        },
    };
}
//# sourceMappingURL=coinbase-wallet.js.map